import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Box, Text } from 'localmed-core';

import LocationAlt from '../../../../../legacyCore/icons/LocationAlt';

const StyledBox = styled(Box)(
  ({ theme, active }) => css`
    display: flex;
    align-items: center;
    color: ${active ? theme.colors.black : theme.colors.blue};
    line-height: ${theme.lineHeights.text};
    svg {
      width: ${theme.space.xl};
      height: ${theme.space.xl};
      color: ${active ? theme.colors.red : theme.colors.gray};
      z-index: 1;
    }

    .marker_number {
      font-size: ${theme.fontSizes.md};
      font-weight: ${active ? theme.fontWeights.bold : 'normal'};
      color: ${theme.colors.white};
      position: absolute;
      top: ${theme.space.sm};
      left: 50%;
      transform: translatex(-50%);
    }
  `
);

export default function OfficeSelectMarker({ office, index, active }) {
  const { address1, address2, city, state, postalCode } = office;
  return (
    <StyledBox active={active}>
      <Box position="relative">
        <LocationAlt />
        <Box className="marker_number">{index + 1}</Box>
      </Box>
      <Box>
        <Text fontSize="md">
          {address1}
          {address2 && `, ${address2}`}
        </Text>
        <Text fontSize="md">
          {city}, {state} {postalCode}
        </Text>
      </Box>
    </StyledBox>
  );
}
